var exports = {
  "k": "x93eb46d8--de6207--container",
};

module.exports = exports;
